var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState, useEffect } from "react";
import { useEnvContext } from "@gw/env-context";
import { useNotificationsCtx, TNotificationType } from "@gw/component-library";
import { login as baseLogin, createUser as baseCreateUser, updateUser as baseUpdateUser, deleteUser as baseDeleteUser, listUsers as baseListUsers, listUser as baseListUser, userProfile as baseUserProfile, updateUserProfile as baseUpdateUserProfile, completeRegistration as baseCompleteRegistration, requestPwdResetCode as baseRequestPwdResetCode, resetPwdWithCode as baseResetPwdWithCode, } from "../api-calls";
import { persistUser, removePersistedUser, getPersistedUser, } from "../helpers/authPersistance";
import { isAdmin, isUser, validateUserAccessToken } from "../helpers/validators";
export var bnIdentityGenerator = function (bnApiUrl) {
    var user = null;
    var login = function (username, password) {
        return baseLogin(bnApiUrl, username, password);
    };
    var logout = function () { };
    var completeRegistration = function (email, code, password, passwordRepeat) {
        return baseCompleteRegistration(bnApiUrl, email, code, password, passwordRepeat);
    };
    var requestPwdResetCode = function (email, recaptcha_token) {
        return baseRequestPwdResetCode(bnApiUrl, email, recaptcha_token);
    };
    var resetPwdWithCode = function (email, code, password, password_confirmation) {
        return baseResetPwdWithCode(bnApiUrl, email, code, password, password_confirmation);
    };
    var isAdmin = function () { return false; };
    var isUser = function () { return false; };
    var createUser = function (u) {
        return baseCreateUser(bnApiUrl, "", u);
    };
    var updateUser = function (u, userId) {
        return baseUpdateUser(bnApiUrl, "", u, userId);
    };
    var deleteUser = function (userId) {
        return baseDeleteUser(bnApiUrl, "", userId);
    };
    var listUsers = function () {
        return baseListUsers(bnApiUrl, "");
    };
    var listUser = function (userId) {
        return baseListUser(bnApiUrl, "", userId);
    };
    var userProfile = function () {
        return baseUserProfile(bnApiUrl, "");
    };
    var updateUserProfile = function (u) {
        return baseUpdateUserProfile(bnApiUrl, "", u);
    };
    return {
        isReady: false,
        user: user,
        login: login,
        logout: logout,
        completeRegistration: completeRegistration,
        requestPwdResetCode: requestPwdResetCode,
        resetPwdWithCode: resetPwdWithCode,
        isAdmin: isAdmin,
        isUser: isUser,
        createUser: createUser,
        updateUser: updateUser,
        deleteUser: deleteUser,
        listUsers: listUsers,
        listUser: listUser,
        userProfile: userProfile,
        updateUserProfile: updateUserProfile,
    };
};
export var useBNIdentityProvider = function (bnApiUrl) {
    var bnTokenRevalidationThreshold = useEnvContext().bnTokenRevalidationThreshold;
    var addNotification = useNotificationsCtx().addNotification;
    var _a = useState(false), isReady = _a[0], setIsReady = _a[1];
    var _b = useState(getPersistedUser()), user = _b[0], setUser = _b[1];
    useEffect(function () {
        if (user !== null) {
            var validFor = validateUserAccessToken(user);
            if (validFor < bnTokenRevalidationThreshold) {
                setUser(null);
                removePersistedUser();
            }
            else {
                var renewalTime = validFor;
                window.setTimeout(function () {
                    removePersistedUser();
                    setUser(null);
                    addNotification("Your session has expired, please log in again.", TNotificationType.warning);
                }, renewalTime * 1000);
            }
        }
        setIsReady(true);
    }, [user]);
    var _c = bnIdentityGenerator(bnApiUrl), login = _c.login, completeRegistration = _c.completeRegistration, requestPwdResetCode = _c.requestPwdResetCode, resetPwdWithCode = _c.resetPwdWithCode;
    var overloadedLogin = function (username, password) { return __awaiter(void 0, void 0, void 0, function () {
        var user;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, login(username, password)];
                case 1:
                    user = _a.sent();
                    setUser(user);
                    persistUser(user);
                    return [2, user];
            }
        });
    }); };
    var logout = function () {
        setUser(null);
        removePersistedUser();
    };
    var overloadedIsAdmin = function () {
        return user ? isAdmin(user) : false;
    };
    var overloadedIsUser = function () {
        return user ? isUser(user) : false;
    };
    var createUser = function (u) {
        return baseCreateUser(bnApiUrl, (user === null || user === void 0 ? void 0 : user.accessToken) || "", u);
    };
    var updateUser = function (u, userId) {
        return baseUpdateUser(bnApiUrl, (user === null || user === void 0 ? void 0 : user.accessToken) || "", u, userId);
    };
    var deleteUser = function (userId) {
        return baseDeleteUser(bnApiUrl, (user === null || user === void 0 ? void 0 : user.accessToken) || "", userId);
    };
    var listUsers = function () {
        return baseListUsers(bnApiUrl, (user === null || user === void 0 ? void 0 : user.accessToken) || "");
    };
    var listUser = function (userId) {
        return baseListUser(bnApiUrl, (user === null || user === void 0 ? void 0 : user.accessToken) || "", userId);
    };
    var userProfile = function () {
        return baseUserProfile(bnApiUrl, (user === null || user === void 0 ? void 0 : user.accessToken) || "");
    };
    var updateUserProfile = function (u) {
        return baseUpdateUserProfile(bnApiUrl, (user === null || user === void 0 ? void 0 : user.accessToken) || "", u);
    };
    return {
        isReady: isReady,
        user: user,
        login: overloadedLogin,
        logout: logout,
        completeRegistration: completeRegistration,
        requestPwdResetCode: requestPwdResetCode,
        resetPwdWithCode: resetPwdWithCode,
        isAdmin: overloadedIsAdmin,
        isUser: overloadedIsUser,
        createUser: createUser,
        updateUser: updateUser,
        deleteUser: deleteUser,
        listUsers: listUsers,
        listUser: listUser,
        userProfile: userProfile,
        updateUserProfile: updateUserProfile,
    };
};
//# sourceMappingURL=useBNIdentityProvider.js.map